var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"title":"Перейти в админ панель"},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_c('Settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }